import Model, { attr, belongsTo } from '@ember-data/model';

export default class MenuModel extends Model {
  @attr('string') codigo;

  @attr('string') nombre;

  @attr('string') titulo;

  @attr('string') descripcion;

  @attr('number', { defaultValue: 0 }) orden;

  @attr('string') ruta;

  @attr('string') params;

  @attr('string') queryParams;

  @attr('boolean', { defaultValue: true }) activo;

  @attr('boolean') soloSuperAdmin;

  @belongsTo('menu', { async: false, inverse: null }) superior;

  get activoFormatted() {
    return this.activo ? 'Sí' : 'No';
  }
}
